import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=3600eea1&scoped=true"
import script from "./SearchModal.vue?vue&type=script&lang=ts"
export * from "./SearchModal.vue?vue&type=script&lang=ts"
import style0 from "./SearchModal.vue?vue&type=style&index=0&id=3600eea1&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3600eea1",
  null
  
)

export default component.exports